import api from "./core";

const basePath = "api/core/ChartNote";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  }
};
